import { ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import React, { useState } from "react";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useTheme } from "@emotion/react";
import ContentEditorModal from "components/markdown-editor/ContentEditorModal";

export default function AITextEditMenuItem({ text, setText, handleClose }) {

  const [editorOpen, setEditorOpen] = useState(false);
  const theme = useTheme();

  const handleSave = (oldText, newText) => {
    setText(newText);
    setEditorOpen(false);
    handleClose();
  } 

  return (
    <>
      <ContentEditorModal
        open={editorOpen}
        onClose={() => setEditorOpen(false)}
        paragraphContent={text}
        updateParagraph={handleSave}
      />
      <MenuItem onClick={() => setEditorOpen(true)}>
        <ListItemIcon
          sx={{
            color: theme.palette.text.main,
          }}
        >
          <AutoFixHighIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>AI Tools</ListItemText>
      </MenuItem>
    </>
  );
}
